import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import LoaderAnimation from '@/assets/img/loader-animation.svg';
import ErrorBaseView, { ErrorBaseViewController } from '@/components/tax-refund/common/view/ErrorView/ErrorBaseView';
import { COMMON_PATHS } from '@/lib/constants/paths';

const NoResponseError = () => {
  const router = useRouter();
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    timer.current = setTimeout(() => {
      router.replace(COMMON_PATHS.환급조회목록);
    }, 3000);

    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
  }, [router]);

  const errorBaseViewController: ErrorBaseViewController = {
    graphic: <LoaderAnimation width={80} height={80} />,
    title: '일정 시간 조회 화면을 떠나\n화면이 새로고침됩니다'
  };

  return <ErrorBaseView viewController={errorBaseViewController} />;
};

export default NoResponseError;
